import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  size?: 'md' | 'xl' | undefined;
}

export const PauseIcon = styled.span<IProps>`
  transform: translateZ(0);
  ${mixin.flex({})};
  overflow: hidden;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 56px;
  width: 32px;
  height: 32px;
  transition: opacity 0.3s;
  ${mixin.flex({})};
  column-gap: 4px;

  .line {
    display: inline-block;
    width: 3px;
    height: 12px;
    background-color: #fff;
  }

  ${props => {
    if (props.size === 'xl') {
      return css`
        width: 56px;
        height: 56px;
        column-gap: 6px;

        .line {
          width: 4px;
          height: 18px;
        }
      `;
    }

    return null;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('50')};
    width: ${mixin.pxToVw('32')};
    height: ${mixin.pxToVw('32')};
    column-gap: ${mixin.pxToVw('4')};

    .line {
      width: ${mixin.pxToVw('2')};
      height: ${mixin.pxToVw('14')};
    }

    ${props => {
      if (props.size === 'xl') {
        return css`
          width: ${mixin.pxToVw('56')};
          height: ${mixin.pxToVw('56')};
          column-gap: ${mixin.pxToVw('6')};

          .line {
            width: ${mixin.pxToVw('4')};
            height: ${mixin.pxToVw('18')};
          }
        `;
      }

      return null;
    }}
  }
`;
